import api from './api';

const DEFAULT_PAGINATION = {
  total: 0,
  current_page: 1,
  per_page: 25,
  last_page: 1
};

const normalizePagination = (pagination = {}) => ({
  total: Number(pagination.total || 0),
  current_page: Number(pagination.current_page || DEFAULT_PAGINATION.current_page),
  per_page: Number(pagination.per_page || DEFAULT_PAGINATION.per_page),
  last_page: Math.max(1, Number(pagination.last_page || DEFAULT_PAGINATION.last_page))
});

export const fetchIssuedLoans = async ({
  search = '',
  date_from = '',
  date_to = '',
  status = 'active',
  page = 1,
  per_page = 25
} = {}) => {
  const response = await api.get('/loans', {
    params: {
      search: search || undefined,
      date_from: date_from || undefined,
      date_to: date_to || undefined,
      status: status || 'active',
      page,
      per_page
    }
  });

  const payload = response.data?.data || {};

  return {
    loans: Array.isArray(payload.loans) ? payload.loans : [],
    pagination: normalizePagination(payload.pagination)
  };
};

export default fetchIssuedLoans;
